export default __webpack_public_path__ + "static/media/logo-colored.cf298825.png";